<template>
  <v-container fluid class="d-flex flex-column fill-height">
    <v-card
      tile
      flat
      class="elevation-0 overflow-y-auto ma-auto"
      width="90vw"
      height="calc(90vh - 90px)"
    >
      <v-row class="ma-0 pa-0">
        <v-col align="center" class="d-flex justify-center align-center">
          <v-radio-group
            v-model="selectUser"
            @change="saveDataOnLocalStorage"
            class="me-7"
            :disabled="loading"
          >
            <v-row class="ma-0 pa-0" align="baseline">
              <v-radio
                :label="$t('common.createUser')"
                :value="false"
                class="me-5"
              ></v-radio>
              <v-radio :label="$t('common.selectUser')" :value="true"></v-radio>
            </v-row>
          </v-radio-group>

          <v-autocomplete
            ref="userAutocomplete"
            solo
            clearable
            open-on-clear
            v-model="user"
            @change="saveDataOnLocalStorage"
            @focus="activateSelectUser"
            @mousedown.native="activateSelectUser"
            :items="users"
            :label="$t('common.user')"
            class="mt-4"
            :color="primaryColor"
            dense
            item-text="email"
            item-value="id_google"
            return-object
            :disabled="loading || loadingUsers"
            :loading="loading || loadingUsers"
            :style="`max-width: ${userInputLength * 11 || 300}px`"
          />
        </v-col>
      </v-row>

      <v-form ref="form" v-model="valid" @submit.prevent="">
        <v-row class="ma-0 pa-0">
          <v-col align="center" cols="6">
            <v-text-field
              v-model="name"
              :label="`${$t('common.name')} *`"
              :rules="[rules.nameMinSize]"
              :disabled="loading || selectUser"
              @input="saveDataOnLocalStorage"
            />
          </v-col>
          <v-col align="center" cols="6">
            <v-text-field
              v-model="lastName"
              :label="`${$t('common.lastName')} *`"
              :rules="[rules.nameMinSize]"
              :disabled="loading || selectUser"
              @input="saveDataOnLocalStorage"
            />
          </v-col>

          <v-col align="center" cols="12">
            <v-row align="baseline" class="ma-0 pa-0">
              <v-col class="pa-0">
                <v-text-field
                  v-model="emailName"
                  :label="`${$t('common.primaryEmail')} *`"
                  :rules="[rules.required, rules.validEmail]"
                  :disabled="loading || selectUser"
                  @focus="autoCompleteUserName"
                  @input="saveDataOnLocalStorage"
                  @change="handleDomainChange"
                />
              </v-col>
              <v-col class="pa-0">
                <v-select
                  v-model="domain"
                  :items="domains"
                  :label="$t('common.domain')"
                  :rules="[rules.required]"
                  :disabled="loading || selectUser"
                  prepend-icon="ph-at"
                  @change="handleDomainChange"
                />
              </v-col>
            </v-row>
          </v-col>
          <!-- IMAGE USER  -->
          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <div class="d-flex flex-column justify-center">
                  <span :class="`pb-2 ${selectUser ? 'disabled' : ''}`">
                    {{ $t("onboardingNewUser.userProfilePhoto") }}
                  </span>
                  <FileUploader
                    v-if="!file && !selectUser"
                    @change="file = $event"
                    type="image"
                    :title="$t('onboardingNewUser.userProfilePhoto')"
                    :buttonText="$t('onboardingNewUser.uploadImage')"
                  />
                  <div v-else class="mt-4">
                    <v-file-input
                      v-model="file"
                      outlined
                      @update:error="logoError = $event"
                      accept="image/*"
                      prepend-icon=""
                      color="primary"
                      :label="$t('common.image')"
                      clear-icon="ph-trash"
                      clearable
                      :disabled="loading || selectUser"
                    >
                      <!-- <template #append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            @click="showCropperDialog = true"
                            v-text="'ph-crop'"
                            color="primary"
                          />
                        </template>
                        <span>Recortar imagem</span>
                      </v-tooltip>
                    </template> -->
                    </v-file-input>
                  </div>
                </div>
              </v-col>

              <!-- UOs  -->
              <v-col cols="6">
                <v-col class="pa-0">
                  <div class="d-flex flex-column justify-center">
                    <span
                      :class="`pb-2 lighten-4 ${selectUser ? 'disabled' : ''}`"
                    >
                      {{ $t("common.organizationUnit") }}
                    </span>
                    <UosPicker
                      returnPath
                      singleChoice
                      :selected="uoSelected"
                      @update="
                        uoSelected = $event;
                        saveDataOnLocalStorage();
                      "
                      :disabled="loading || selectUser"
                    />
                  </div>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pt-7">
            <v-divider />
          </v-col>

          <!-- LICENÇAS DO USUÁRIO -->
          <v-col v-if="licenseLimiterSettingsIsActive" cols="12">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="pa-0 ma-0">
                <span
                  :class="`font-weight-bold pr-4 text-h6 ${
                    selectUser ? 'disabled' : ''
                  }`"
                >
                  {{ $t("onboardingNewUser.userLicenses") }}
                </span>
                <TooltipIcon
                  color="primary"
                  :label="$t('onboardingNewUser.userLicensesDescription')"
                  :disabled="loading || selectUser"
                  icon="ph-fill ph-info"
                />
              </v-col>

              <v-col cols="12" v-if="loadingDomainLicenses">
                <v-progress-linear indeterminate color="primary" />
              </v-col>

              <v-col cols="6" class="pa-0 ma-0 mt-4" v-else>
                <v-autocomplete
                  v-model="selectedLicenses"
                  :items="mergedAvailableLicenses"
                  :loading="loadingDomainLicenses"
                  item-text="sku_name"
                  item-value="sku_id"
                  :label="$t('onboardingNewUser.selectLicenses')"
                  multiple
                  chips
                  outlined
                  dense
                  :disabled="loading || !domain || selectUser"
                  @change="saveDataOnLocalStorage"
                >
                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    <v-chip
                      v-bind="!isIdentityFree(item) ? attrs : {}"
                      :input-value="selected || isIdentityFree(item)"
                      pill
                      class="ma-1"
                    >
                      <span class="px-2">{{ item.sku_name }}</span>
                      <v-tooltip bottom v-if="isLicenseExceeded(item)">
                        <template
                          v-slot:activator="{ on, attrs: tooltipAttrs }"
                        >
                          <v-icon
                            v-bind="tooltipAttrs"
                            v-on="on"
                            color="error"
                            size="x-large"
                            class="pr-2"
                            v-text="'ph-prohibit'"
                          />
                        </template>
                        <span>{{
                          $t("onboardingNewUser.licenseLimitExceededMessage")
                        }}</span>
                      </v-tooltip>
                      <v-icon
                        v-if="!isIdentityFree(item) && !selectUser"
                        color="secondary lighten-1"
                        @click="parent.selectItem(item)"
                        v-text="'ph-x-circle'"
                      />
                    </v-chip>
                  </template>

                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item
                      v-on="
                        !isIdentityFree(item) && !isLicenseExceeded(item)
                          ? on
                          : {}
                      "
                      v-bind="attrs"
                      :input-value="attrs.inputValue || isIdentityFree(item)"
                      active-class="light-blue lighten-5"
                    >
                      <v-list-item-action>
                        <v-checkbox
                          v-model="attrs.inputValue"
                          :color="attrs.inputValue ? 'accent' : 'secondary'"
                          :disabled="
                            isLicenseExceeded(item) || isIdentityFree(item)
                          "
                        />
                      </v-list-item-action>
                      <v-list-item-content class="pl-2">
                        <v-list-item-title
                          :class="{
                            'text--disabled':
                              isLicenseExceeded(item) || isIdentityFree(item),
                          }"
                        >
                          {{ item.sku_name }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          :class="{
                            'text--disabled':
                              isLicenseExceeded(item) || isIdentityFree(item),
                          }"
                        >
                          <span v-if="!isIdentityFree(item)">{{
                            `${item.used_count} / ${
                              item.limit_count === UNLIMITED
                                ? UNLIMITED_LABEL
                                : item.limit_count
                            } ${$t("common.used")}`
                          }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-tooltip
                        bottom
                        max-width="250"
                        v-if="isIdentityFree(item) || isLicenseExceeded(item)"
                      >
                        <template
                          v-slot:activator="{
                            on: tooltipOn,
                            attrs: tooltipAttrs,
                          }"
                        >
                          <v-chip
                            v-bind="tooltipAttrs"
                            v-on="tooltipOn"
                            pill
                            class="font-weight-bold px-4"
                          >
                            <v-icon
                              v-text="
                                isIdentityFree(item) ? 'ph-info' : 'ph-prohibit'
                              "
                              small
                            />
                          </v-chip>
                        </template>
                        <span>{{
                          isIdentityFree(item)
                            ? $t(
                                "onboardingNewUser.licenseAssignedAutomaticallyByGoogle"
                              )
                            : $t(
                                "onboardingNewUser.licenseLimitExceededMessage"
                              )
                        }}</span>
                      </v-tooltip>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-divider class="pt-7" />
          </v-col>

          <!-- PASSWORD  -->
          <v-col cols="12">
            <span
              :class="`font-weight-bold pr-4 text-h6 ${
                selectUser ? 'disabled' : ''
              }`"
            >
              {{ $t("onboardingNewUser.loginAndPasswordManagement") }}
            </span>
            <TooltipIcon
              color="primary"
              :label="
                hasControl
                  ? $t(
                      'onboardingNewUser.loginAndPasswordManagementDescriptionWithControl'
                    )
                  : $t(
                      'onboardingNewUser.loginAndPasswordManagementDescription'
                    )
              "
              :disabled="loading || selectUser"
              icon="ph-fill ph-info"
            />
          </v-col>
          <v-col cols="12">
            <v-radio-group
              v-model="passwordOption"
              :disabled="loading || selectUser"
              @change="saveDataOnLocalStorage"
            >
              <v-row class="ma-0 pa-0" align="baseline">
                <v-col
                  class="ma-0 pa-0"
                  v-for="(option, i) in passwordOptions"
                  :key="i"
                >
                  <v-radio :label="option.label" :value="option.value">
                  </v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0 pr-5 pl-3">
            <v-text-field
              v-model="password"
              :label="`${$t('onboardingNewUser.password')} *`"
              :disabled="
                loading || passwordOption !== 'customPassword' || selectUser
              "
              :rules="passwordRules"
              :append-icon="
                hidePass ? 'ph-fill ph-eye-slash' : 'ph-fill ph-eye'
              "
              :type="hidePass ? 'password' : 'text'"
              @click:append="hidePass = !hidePass"
              @change="saveDataOnLocalStorage"
            />
            <p class="text-subtitle-2 mt-2" style="width: 100%">
              {{ $t("onboardingNewUser.copyOnNextStep") }}
            </p>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0 pr-3">
            <v-text-field
              v-model="confirmPassword"
              :label="`${$t('onboardingNewUser.confirmPassword')} *`"
              :rules="[rules.equalPasswords]"
              :disabled="
                loading || passwordOption !== 'customPassword' || selectUser
              "
              :append-icon="
                hideConfirmPass ? 'ph-fill ph-eye-slash' : 'ph-fill ph-eye'
              "
              :type="hideConfirmPass ? 'password' : 'text'"
              @click:append="hideConfirmPass = !hideConfirmPass"
            />
          </v-col>

          <!-- SWITCHES -->
          <v-col cols="12" class="mt-0 pt-0">
            <v-row>
              <v-col cols="6">
                <v-switch
                  inset
                  v-model="askChangePass"
                  :label="$t('onboardingNewUser.requestPasswordChange')"
                  :disabled="loading || selectUser"
                  @change="saveDataOnLocalStorage"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      <!-- <CropImageDialog
        id="crop-image"
        :key="key"
        :image="cropImagePreview"
        :show="showCropperDialog"
        @close="showCropperDialog = false"
        @crop="setCroppedImage"
      /> -->
    </v-card>

    <v-divider style="width: 90vw"></v-divider>
    <v-footer
      rounded
      style="height: 70px"
      color="background"
      class="border-bottom rounded-xl mt-3"
      width="90vw"
    >
      <v-btn
        text
        height="52"
        color="secondary"
        style="border: 2px solid grey !important"
        class="mx-auto text-none text-body-1 font-weight-medium px-8"
        :disabled="loading"
        outlined
        @click="$emit('back')"
      >
        <v-icon right v-text="'ph-arrow-left'" class="mr-4" size="22" />
        {{ $t("common.back") }}
      </v-btn>

      <v-spacer />

      <v-btn
        height="52"
        color="accent"
        class="mx-auto text-none text-body-1 font-weight-bold px-8 mr-0"
        @click="createUser()"
        :disabled="isCreateButtonDisabled"
        :loading="loading"
      >
        {{ $t("common.advance") }}
        <v-icon right v-text="'ph-arrow-right'" class="ml-4" size="22" />
      </v-btn>
    </v-footer>
  </v-container>
</template>

<script>
// import CropImageDialog from "@/components/general/CropImageDialog.vue";
import FileUploader from "@/components/general/FileUploader.vue";
import UosPicker from "@/components/forms/field_pickers/UosPicker.vue";
import { convertImageIntoBase64 } from "@/helpers/services/images";
import { rules, generateRandomPassword } from "@/helpers/services/utils";
import { setFirebaseEvent } from "@/helpers/services/registerAnalytics.js";
import {
  DEFAULT_PASSWORD_STRENGTH,
  UNLIMITED_LABEL,
  UNLIMITED,
} from "@/helpers/variables/backendConstants";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  errorMessages,
  successMessages,
} from "@/helpers/variables/snackbarMessages";

export default {
  name: "CreateUser",
  components: {
    // CropImageDialog,
    FileUploader,
    UosPicker,
  },

  data() {
    return {
      valid: null,

      name: null,
      lastName: null,
      emailName: null,
      domain: null,
      askChangePass: false,
      passwordOption: "customPassword",

      password: null,
      confirmPassword: null,
      hidePass: true,
      hideConfirmPass: true,
      loading: false,
      file: null,
      logoError: false,
      // showCropperDialog: false,
      key: 0,
      uoSelected: "",
      rules: {
        ...rules,

        equalPasswords: (v) =>
          v === this.password || this.$t("textFieldRules.passwordsDoNotMatch"),

        min_len: (v) =>
          (!!v && v.length >= this.minSize) ||
          `${this.$t("textFieldRules.requiredField")}: ${this.minSize}`,

        nameMinSize: (v) =>
          (!!v && v.length >= 3) ||
          `${this.$t("textFieldRules.requiredField")}: 3`,

        imageRule: (v) =>
          !v || v.size < 2000000 || this.$t("textFieldRules.imageTooLarge"),

        validEmail: (v) =>
          /^[a-zA-Z0-9._%+-]+$/.test(v) ||
          this.$t("textFieldRules.invalidEmail"),
      },
      user: null,
      selectUser: false,
      selectedLicenses: [],
      UNLIMITED_LABEL,
      UNLIMITED,
    };
  },

  computed: {
    ...mapGetters([
      "company",
      "domains",
      "organizationalUnits",
      "secondaryColor",
      "companyHasControl",
      "domainGroup",
      "users",
      "primaryColor",
      "onboardingForms",
      "loadingUsers",
      "domainLicenses",
      "loadingDomainLicenses",
      "licenseLimiterSettingsIsActive",
    ]),
    cropImagePreview() {
      if (this.file) {
        const url = URL.createObjectURL(this.file);
        return url;
      }

      return "";
    },
    uos() {
      return [
        {
          name: "Principal",
          path: "/",
          children: this.organizationalUnits,
        },
      ];
    },
    formData() {
      return {
        selectUser: this.selectUser,
        user: this.user,
        name: this.name,
        lastName: this.lastName,
        emailName: this.emailName,
        domain: this.domain,
        uoSelected: this.uoSelected,
        passwordOption: this.passwordOption,
        askChangePass: this.askChangePass,
        selectedLicenses: this.selectedLicenses,
      };
    },
    checkRequiredFields() {
      const password =
        this.password === this.confirmPassword && this.password !== null;

      return (
        this.name && this.lastName && this.emailName && this.domain && password
      );
    },
    availableLicenses() {
      if (!this.domain || !this.domainLicenses.items[this.domain]) {
        return [];
      }

      const domainLicensesObj = this.domainLicenses.items[this.domain];

      const domainList = Object.keys(domainLicensesObj)
        .filter((licenseName) => licenseName.toLowerCase() !== "total")
        .map((licenseName) => ({
          sku_id: domainLicensesObj[licenseName].key,
          sku_name: licenseName,
          limit_count: domainLicensesObj[licenseName].limit_count,
          used_count: domainLicensesObj[licenseName].used_count,
        }));
      return domainList;
    },

    mergedAvailableLicenses() {
      const domainList = this.availableLicenses || [];
      if (!this.selectUser) return domainList;

      const userItems = this.userLicenseItems || [];
      const existingIds = new Set(domainList.map((d) => String(d.sku_id)));
      const extras = userItems.filter(
        (u) => !existingIds.has(String(u.sku_id))
      );
      return [...extras, ...domainList];
    },

    userLicenseItems() {
      if (!this.user || !this.user.license_keys || !this.selectUser) return [];
      const keysArr = Array.isArray(this.user.license_keys)
        ? this.user.license_keys
        : [];

      return keysArr.map((lk) => {
        const key =
          (lk && (lk.license_key || lk.key || lk.licenseKey)) || String(lk);
        const name =
          (lk && (lk.license_name || lk.licenseName || lk.name)) || String(key);
        return { sku_id: key, sku_name: name };
      });
    },
    hasLicenseExceeded() {
      return this.selectedLicenses.some((skuId) => {
        const license = this.availableLicenses.find((l) => l.sku_id === skuId);
        return this.isLicenseExceeded(license);
      });
    },
    isCreateButtonDisabled() {
      if (this.selectUser) {
        return this.loading || !this.user;
      }
      return (
        this.loading ||
        !this.checkRequiredFields ||
        !this.valid ||
        this.hasLicenseExceeded
      );
    },
    passwordOptions() {
      return [
        {
          label: this.$t("onboardingNewUser.createPassword"),
          value: "customPassword",
        },
        {
          label: this.$t("onboardingNewUser.generateAStrongPassword"),
          value: "generatedPassword",
        },
      ];
    },
    hasControl() {
      return (
        ["PRODUCT_IN_TRIAL_PLAN", "PRODUCT_IN_ACTIVE_PLAN"].includes(
          this.companyHasControl
        ) && this.company.control_last_seen !== null
      );
    },
    passwordRules() {
      const passwordStrength =
        this.domainGroup?.password_strength || DEFAULT_PASSWORD_STRENGTH;

      return Object.entries(passwordStrength)
        .filter((entry) => entry[1])
        .map((entry) => this.rules[entry[0]])
        .concat([this.rules.required]);
    },
    minSize() {
      const minLen = this.domainGroup?.password_strength?.min_len || 8;
      return minLen < 8 ? 8 : minLen;
    },
    userInputLength() {
      return (this.users || []).reduce(
        (total, current) =>
          total > current.email.length ? total : current.email.length,
        0
      );
    },
  },
  watch: {
    passwordOption() {
      if (this.passwordOption === this.passwordOptions[1].value) {
        const passwordGenerated = generateRandomPassword(10);
        this.password = passwordGenerated;
        this.confirmPassword = passwordGenerated;
      }
    },
    hasControl: {
      async handler(hasControl) {
        if (!hasControl) return;
        await this.getControlCompany();
      },
      immediate: true,
    },
    user() {
      if (!this.user) {
        this.reset();
        return;
      }
      this.loadFromUser();
      this.setOnboardingUser(this.user);
    },
    selectUser() {
      if (!this.selectUser) {
        this.user = null;
      }

      if (!this.selectUser) {
        this.$nextTick(() => this.ensureIdentityFreeSelected());
      }
    },
    onboardingForms: {
      handler() {
        this.setFormValuesByLocalStorage();
      },
      immediate: true,
    },
    availableLicenses: {
      handler() {
        this.ensureIdentityFreeSelected();
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations([
      "setSnackBar",
      "setOnboardingForms",
      "setOnboardingUser",
      "setOnboardingCreatedUser",
    ]),
    ...mapActions([
      "createUserOnWorkspace",
      "getControlCompany",
      "getDomainLicenses",
    ]),
    saveAnalytics(log) {
      if (this.mainDomain) {
        setFirebaseEvent(this.mainDomain, log.event, log.click);
      }
    },

    activateSelectUser() {
      if (this.loading || this.loadingUsers) return;

      if (!this.selectUser) {
        this.selectUser = true;
        this.saveDataOnLocalStorage();
      }
    },

    setFormValuesByLocalStorage() {
      const saved = (this.onboardingForms && this.onboardingForms.create) || {};
      const defaults = {
        selectUser: false,
        user: null,
        name: null,
        lastName: null,
        emailName: null,
        domain: null,
        uoSelected: "",
        passwordOption: "customPassword",
        askChangePass: false,
        selectedLicenses: [],
      };

      const merged = { ...defaults, ...saved };

      Object.keys(defaults).forEach((key) => {
        this[key] = merged[key];
      });
    },

    saveDataOnLocalStorage() {
      this.setOnboardingForms({ label: "create", formData: this.formData });
    },

    autoCompleteUserName() {
      if (!this.emailName && this.name) {
        this.emailName = this.removeAccents(this.name)
          .replace(/\s/gm, "")
          .toLowerCase();
      }
    },
    removeAccents(str = "") {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    // setCroppedImage(image) {
    //   this.image = image;
    //   this.showCropperDialog = false;
    // },
    // forceUpdate() {
    //   this.key += 1;
    // },
    reset() {
      this.setOnboardingUser();
      this.$refs.form.reset();
    },

    async handleDomainChange() {
      this.saveDataOnLocalStorage();

      if (!this.domain) {
        this.selectedLicenses = [];
        return;
      }

      if (
        !this.domainLicenses.items[this.domain] ||
        Object.keys(this.domainLicenses.items).length === 0
      ) {
        await this.getDomainLicenses();
      }

      if (this.selectUser && this.user && this.user.license_keys) {
        this.selectedLicenses = Array.isArray(this.user.license_keys)
          ? this.user.license_keys.map((lk) => lk.license_key || lk.key || lk)
          : [];
        this.saveDataOnLocalStorage();
        return;
      }

      this.selectedLicenses = [];
      this.saveDataOnLocalStorage();
      this.ensureIdentityFreeSelected();
    },

    isLicenseExceeded(license) {
      if (!license || license.limit_count === UNLIMITED) {
        return false;
      }
      return license.used_count >= license.limit_count;
    },

    isIdentityFree(license) {
      if (!license || !license.sku_name) return false;
      return license.sku_name.toLowerCase().includes("cloud identity free");
    },

    ensureIdentityFreeSelected() {
      if (this.selectUser) return;
      if (!this.domain) return;
      const licenses = this.availableLicenses || [];
      if (!licenses.length) return;

      const identityFreeLicense = licenses.find(
        (license) =>
          license.sku_name.toLowerCase().includes("cloud identity free") &&
          !this.isLicenseExceeded(license)
      );

      if (!identityFreeLicense) return;

      if (!this.selectedLicenses.includes(identityFreeLicense.sku_id)) {
        this.selectedLicenses = [
          ...this.selectedLicenses,
          identityFreeLicense.sku_id,
        ];
        this.saveDataOnLocalStorage();
      }
    },

    async createUser() {
      this.loading = true;
      if (this.selectUser) {
        const suite_user = this.user;
        this.setOnboardingUser(suite_user);
        this.$emit("user-selected");

        this.loading = false;
        return;
      }

      if (this.hasLicenseExceeded) {
        this.setSnackBar({
          show: true,
          message: this.$t("onboardingNewUser.cannotCreateUserLicenseExceeded"),
          color: "error",
        });
        this.loading = false;
        return;
      }

      let imageBase64 = "";
      let type = "";
      if (this.file) {
        imageBase64 = await convertImageIntoBase64(this.file);
        type = this.file.type;
      }
      let payload = {
        family_name: this.lastName,
        given_name: this.name,
        full_name: `${this.name} ${this.lastName}`,
        password: this.password,
        primary_email: `${this.emailName}@${this.domain}`,
        change_password_at_next_login: !!this.askChangePass,
        org_unit_path:
          this.uoSelected && this.uoSelected.length ? this.uoSelected : "/",
        photo: {
          photoData: imageBase64,
          mimeType: type,
        },
        licenses: this.selectedLicenses,
      };

      const log = {
        event: "create_user_onboarding",
        click: "Botão de criar usuário",
      };
      this.saveAnalytics(log);

      this.createUserOnWorkspace(payload)
        .then(async ({ data }) => {
          const { suite_user_created } = data;

          this.setOnboardingUser(suite_user_created);

          this.setSnackBar({
            show: true,
            message: successMessages.user_created,
            color: "success",
          });
          const createdUser = {
            email: payload.primary_email,
            password: payload.password,
          };
          this.setOnboardingCreatedUser(createdUser);
          this.$emit("user-created");
        })
        .catch((error) => {
          console.error("createUserOnWorkspace: ", error.response);
          const { response } = error;
          const {
            USER_DUPLICATED_ERROR,
            INVALID_DATA,
            INVALID_GOOGLE_ACCESS_TOKEN,
            USERS_NUMBER_LIMIT_EXCEEDED,
          } = errorMessages;
          const mappedErrors = {
            409: USER_DUPLICATED_ERROR,
            412: USERS_NUMBER_LIMIT_EXCEEDED,
            INVALID_GOOGLE_ACCESS_TOKEN,
          };
          const mappedError = mappedErrors[response.status];
          const errorMessage = mappedError
            ? mappedError
            : mappedErrors[response.data.code] || INVALID_DATA;

          this.setSnackBar({
            show: true,
            message: errorMessage,
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadFromUser() {
      if (!this.user) return;
      const emailSplit = this.user.email.split("@");

      this.name = this.user.first_name;
      this.lastName = this.user.last_name;
      this.emailName = emailSplit[0];
      this.domain = emailSplit[1];
      this.uoSelected = this.user.ou;
      this.passwordOption = null;
      this.askChangePass = false;

      this.saveDataOnLocalStorage();
      if (this.user && this.user.license_keys) {
        this.selectedLicenses = Array.isArray(this.user.license_keys)
          ? this.user.license_keys.map((lk) => lk.license_key || lk.key || lk)
          : [];
        this.saveDataOnLocalStorage();
      }
    },
  },
  beforeMount() {
    localStorage.removeItem("userGroups");
  },
};
</script>

<style scoped>
.treeview-style {
  overflow-x: scroll;
  overflow-y: scroll;
}
.cursor {
  cursor: pointer !important;
}
.disabled {
  color: rgba(0, 0, 0, 0.38) !important;
}
</style>
